





















































































import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { paymentReportService } from '@/shared';
import { VHeaders } from '@/models/pagedlistmodel';

@Component({
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
  },
})
export default class CreditCardFeeOverrideReportPage extends Base {

  public loading = false;

  public isSearchLoading = false;

  public items: any[] = [];

  public allItems: any[] = [];

  public searchText = '';

  public flags = {
    invalidUrl: false,
    showReportDatePicker: false,
  };

  public typedLabel = '';

  public todayDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0];

  public params = {
    reportDate: '',
  };

  public headers: VHeaders[] = [
    
    {
      text: 'Customer',
      value: 'customerName',
      sortable: false,
    },
    {
      text: 'Amount',
      value: 'totalAmount',
      sortable: false,
    },
    {
      text: 'Transaction Id',
      value: 'transactionId',
      sortable: false,
    },
    {
      text: 'Transaction Type',
      value: 'typeOfTransaction',
      sortable: false,
    },
    {
      text: 'Payment Method',
      value: 'paymentMethod',
      sortable: false,
    },
    {
      text: 'Card Type',
      value: 'cardType',
      sortable: false,
    },
    {
      text: 'Created By',
      value: 'userName',
      sortable: false,
    },
    {
      text: 'Reason',
      value: 'reason',
      sortable: false,
    },
  ];

  public created(): void {
    this.params.reportDate = this.todayDate;
    this.typedLabel = this.formatDate(this.todayDate);
  }

  public mounted(): void {
    this.$root.$emit(
      'sidebar.layout.vue',
      'CreditCardFeeOverrideReport'
    );
  }

  public onDatePickerInput(): void {
    this.typedLabel = this.formatDate(this.params.reportDate);
    this.flags.showReportDatePicker = false;
  }

  public onReportDateInput(value: string): void {
    this.typedLabel = value;

    // Keep the actual query param in sync with the typed value.
     const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
     if (!match) {
       this.params.reportDate = '';
       return;
     }
     const [, mm, dd, yyyy] = match;
     const m = Number(mm);
     const d = Number(dd);
     const y = Number(yyyy);
     const date = new Date(y, m - 1, d);
     if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
       this.params.reportDate = '';
       return;
     }
     const iso = `${yyyy}-${mm}-${dd}`;
     if (iso > this.todayDate) {
       this.params.reportDate = '';
       return;
     }
     this.params.reportDate = iso;
  }

  private formatDate(date: string): string {
    if (!date) {
      return '';
    }

    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  public async searchCreditCardFeeOverridePayments(): Promise<void> {
    
    if (!this.params.reportDate) {
       this.showAlert(false, 'Please select a valid report date.');
       return;
     }

    try {
      this.loading = true;

      const fromDate = `${this.params.reportDate}T00:00:00`;
      const toDate = `${this.params.reportDate}T23:59:59`;

      const response = await paymentReportService.GetCreditCardFeeOverrideReport(
         fromDate,
         toDate
       );

      this.allItems = response || [];
      this.filterData();
     } finally {
       this.loading = false;
     }
  }

  public download(): void {

  if (!this.items || this.items.length === 0) {
    this.showAlert(false,'No records available to download.');
    return;
  }

  const headers = [
    'Transaction Id',
    'Transaction Type',
    'Record Key',
    'Customer',
    'Payment Method', 
    'Card Type',
    'Amount',
    'Reason'
  ];

  const rows = this.items.map(x => [
    x.transactionId,
    x.typeOfTransaction,
    x.recordKey,
    x.customerName,
    x.paymentMethod,
    x.cardType,
    x.totalAmount,
    x.reason
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(r =>
      r.map(v => `"${(v ?? '').toString().replace(/"/g, '""')}"`).join(',')
    )
  ].join('\n');

  const blob = new Blob(
    [csvContent],
    { type: 'text/csv;charset=utf-8;' }
  );

  const link = document.createElement('a');
  const url = window.URL.createObjectURL(blob);

  link.href = url;
  link.setAttribute(
    'download',
    `CreditCardFeeOverrideReport_${this.params.reportDate}.csv`
  );

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

  public filterData(): void {

  const search = this.searchText?.toLowerCase().trim();

  if (!search) {
    this.items = [...this.allItems];
    return;
  }

  this.items = this.allItems.filter(item =>
    Object.values(item).some(value =>
      value !== null &&
       value !== undefined &&
      value.toString().toLowerCase().includes(search)
    )
  );
}

}
